import { db } from "../../firebase";
import { toast } from "react-toastify";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
  addDoc,
  deleteDoc,
} from "firebase/firestore";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import dayjs from "dayjs";

// Firebase configuration for secondary app (for user creation)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const getUserEvents = async (uid, year) => {
  if (!uid || !year) {
    toast.error("User ID or Year is required");
    return [];
  }
  try {
    const eventsRef = collection(db, "userEvents");
    const q = query(
      eventsRef,
      where("uid", "==", uid),
      where("year", "==", year.toString()),
    );
    const snapshot = await getDocs(q);

    return snapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .sort((a, b) => new Date(a.datetime) - new Date(b.datetime));
  } catch (err) {
    console.error("Failed to fetch user events:", err);
    toast.error(err?.message || "Πρόβλημα στην ανάκτηση των ομιλιών");
    return [];
  }
};

export const createUserEvent = async (eventData) => {
  try {
    const docRef = await addDoc(collection(db, "userEvents"), eventData);
    toast.success("Ομιλία δημιουργήθηκε με επιτυχία");
    try {
      fetch(
        "https://mops-notifications-server-c3j1.vercel.app/send-notification",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            title: `Νέα ομιλία - ${dayjs(eventData?.datetime).format("DD/MM/YYYY")}`,
            body: `Έχεις ομιλία στην εκκλησία ${eventData?.meetingHouse}. Αριθμός ομιλίας: ${eventData?.number}`,
            uid: eventData.uid,
          }),
        },
      );
    } catch (e) {
      console.log(e);
    }

    try {
      fetch(
        "https://mops-notifications-server.vercel.app/api/notifications/send-to-user",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            title: `Νέα ομιλία - ${dayjs(eventData?.datetime).format("DD/MM/YYYY")}`,
            body: `Έχεις ομιλία στην εκκλησία ${eventData?.meetingHouse}. Αριθμός ομιλίας: ${eventData?.number}`,
            userId: eventData.uid,
            token: "valeriosTopG",
            data: {
              action: "view_schedule",
            },
          }),
        },
      );
    } catch (e) {
      console.log(e);
    }

    return docRef.id;
  } catch (error) {
    console.error("Failed to create user event:", error);
    toast.error(error?.message || "Σφάλμα κατά τη δημιουργία ομιλίας");
    return null;
  }
};

export const updateUserEventStatus = async (data) => {
  const { eventId, newStatus } = data || {};
  if (!eventId || !newStatus) {
    toast.error("Missing event ID or status");
    return;
  }

  try {
    const eventRef = doc(db, "userEvents", eventId);
    await updateDoc(eventRef, { status: newStatus });
    toast.success(
      `${newStatus === "accepted" ? "Αποδέχτηκε" : "Απορρίφθηκε"} η ομιλία, καλή επιτυχία!`,
    );
  } catch (err) {
    console.error("Error updating event status:", err);
    toast.error(err?.message || "Πρόβμηλα στην ενημέρωση της ομιλίας");
  }
};

export const getAllUsers = async () => {
  try {
    const eventsRef = collection(db, "users");
    const snapshot = await getDocs(eventsRef);

    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (err) {
    console.error("Failed to fetch user events:", err);
    toast.error(err?.message || "Πρόβλημα στην ανάκτηση των ομιλιών");
    return [];
  }
};

export const getAllUserEvents = async (year) => {
  if (!year) {
    toast.error("Year is required");
    return [];
  }
  try {
    const eventsRef = collection(db, "userEvents");
    const q = query(eventsRef, where("year", "==", year.toString()));
    const snapshot = await getDocs(q);

    return snapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .sort((a, b) => new Date(a.datetime) - new Date(b.datetime));
  } catch (err) {
    console.error("Failed to fetch user events:", err);
    toast.error(err?.message || "Πρόβλημα στην ανάκτηση των ομιλιών");
    return [];
  }
};

export const deleteUserEvent = async (data) => {
  const { id } = data || {};
  if (!id) {
    toast.error("Το ID της ομιλίας είναι απαραίτητο");
    return;
  }
  try {
    await deleteDoc(doc(db, "userEvents", id));
    toast.success("Η ομιλία διαγράφηκε με επιτυχία");
  } catch (error) {
    console.error("Failed to delete user event:", error);
    toast.error(error?.message || "Σφάλμα κατά τη διαγραφή της ομιλίας");
  }
};

export const updateFirebaseToken = async (uid, token) => {
  if (!uid) {
    toast.error("Missing uid");
    return;
  }
  try {
    const usersRef = collection(db, "users");
    const q = query(usersRef, where("uid", "==", uid));
    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      console.warn("No matching user found for UID:", uid);
      return;
    }
    const userDoc = snapshot.docs[0].ref;
    await updateDoc(userDoc, { firebaseToken: token });
    return true;
  } catch (err) {
    console.error("Error updating event status:", err);
    toast.error(err?.message || "Πρόβμηλα στην ενημέρωση της ομιλίας");
  }
};

export const updateUser = async (userId, userData) => {
  if (!userId) {
    toast.error("User ID is required");
    return false;
  }
  try {
    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, userData);
    toast.success("Ο χρήστης ενημερώθηκε με επιτυχία");
    return true;
  } catch (error) {
    console.error("Failed to update user:", error);
    toast.error(error?.message || "Σφάλμα κατά την ενημέρωση του χρήστη");
    return false;
  }
};

export const deleteUser = async (userId) => {
  if (!userId) {
    toast.error("User ID is required");
    return false;
  }
  try {
    await deleteDoc(doc(db, "users", userId));
    toast.success("Ο χρήστης διαγράφηκε με επιτυχία");
    return true;
  } catch (error) {
    console.error("Failed to delete user:", error);
    toast.error(error?.message || "Σφάλμα κατά τη διαγραφή του χρήστη");
    return false;
  }
};

export const createUser = async (userData) => {
  const { email, password, fullname, role = "user", congregation } = userData;

  if (!email || !password || !fullname) {
    toast.error("Όλα τα πεδία είναι υποχρεωτικά");
    return false;
  }

  try {
    // Create a secondary Firebase app instance for user creation
    // This prevents affecting the main app's authentication state
    const secondaryApp = initializeApp(firebaseConfig, "UserCreationApp");
    const secondaryAuth = getAuth(secondaryApp);

    // Create user with the secondary Firebase Auth instance
    const userCredential = await createUserWithEmailAndPassword(
      secondaryAuth,
      email,
      password,
    );
    const user = userCredential.user;

    // Create user document in Firestore using the main database connection
    const userDocData = {
      uid: user.uid,
      email: user.email,
      emailVerified: user.emailVerified,
      fullname,
      role,
      congregation,
      createdAt: new Date(),
      firebaseToken: null,
    };

    await addDoc(collection(db, "users"), userDocData);

    // Sign out from the secondary auth instance to clean up
    await signOut(secondaryAuth);

    toast.success("Ο χρήστης δημιουργήθηκε με επιτυχία");
    return { id: user.uid, ...userDocData };
  } catch (error) {
    console.error("Failed to create user:", error);

    // Handle specific Firebase Auth errors
    if (error.code === "auth/email-already-in-use") {
      toast.error("Αυτό το email χρησιμοποιείται ήδη");
    } else if (error.code === "auth/weak-password") {
      toast.error("Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες");
    } else if (error.code === "auth/invalid-email") {
      toast.error("Μη έγκυρο email");
    } else {
      toast.error(error?.message || "Σφάλμα κατά τη δημιουργία του χρήστη");
    }

    return false;
  }
};
